import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
} from 'vue-router';
import { getSdk } from '@descope/vue-sdk';
import Success from './components/subscription/Success.vue';
import AsyncLoadingWrapper from './components/Common/AsyncLoadingWrapper.vue';
import { useSessionStore } from './stores/session';
import { isLoggedIn } from './api/loginApi';
import { useSubscriptionStore } from './stores/subscription';
import SubscriptionManagement from './components/subscription/SubscriptionManagement.vue';
import NewSubscription from './components/subscription/NewSubscription.vue';
import { clientWithoutInterceptors } from './utils/http';
import config from './config';
import Segment from './Segment';

const routes = [
  {
    path: '/',
    name: 'UnAuthenticatedRoutes',
    component: AsyncLoadingWrapper,
    beforeEnter: _verifyLogin,
    children: [
      {
        path: 'subscription',
        component: async () => (await _isSubscribed() ? SubscriptionManagement : NewSubscription),
      },
      {
        path: '/success',
        component: Success,
      },
    ],
  },
];

async function _verifyLogin(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> {
  const { token } = to.query;
  if (token && typeof token === 'string') {
    // const tokenValue = token;
    const isDescopeAutheticated = await _descopeAutheticate(token);
    if (isDescopeAutheticated) {
      await _initSession();
      return next();
    }
  }
  const isAuthenticated = await _isAuthenticated();
  if (isAuthenticated) {
    return next();
  }
  // needs to redirect to login
  window.location.href = config.get().loginUrl;
  return next();
}

async function _initSession() {
  const sessionStore = useSessionStore();
  await sessionStore.init();

  if (sessionStore.customerId && sessionStore.memberId) {
    Segment.identifyCustomer(sessionStore.customerId, sessionStore.memberId);
  }
}
async function _isAuthenticated(): Promise<boolean> {
  const loggedIn = await isLoggedIn();
  if (loggedIn) {
    await _initSession();
    return true;
  }

  return false;
}

async function _descopeAutheticate(token: string): Promise<boolean> {
  if (token) {
    const descopeSdk = getSdk();
    const magicLinkResp = await descopeSdk.magicLink.verify(token);
    if (magicLinkResp.code !== 200) {
      return false;
    }
    // exchange for riseup token
    const response = await clientWithoutInterceptors.get('/api/no-auth/descope/login', {
      headers: {
        Authorization: `Bearer ${magicLinkResp?.data?.sessionJwt}`,
      },
    });
    return response.status === 200;
  }
  return false;
}

async function _isSubscribed(): Promise<boolean> {
  const subscriptionStore = useSubscriptionStore();
  await subscriptionStore.init();
  return subscriptionStore.isSubscribed;
}

const router = createRouter({
  history: createWebHistory(),
  routes,
});
export default router;
